"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hooks = void 0;
const react_1 = require("react");
class Hooks {
    static usePromise(promiseFactory, deps) {
        const [state, setState] = (0, react_1.useState)();
        (0, react_1.useEffect)(() => {
            let abort = false;
            promiseFactory()
                .then(newState => !abort && setState(newState))
                .catch((err) => {
                !abort && setState(undefined);
                if (!err.message.includes(`Account does not exist `)) {
                    console.log(err);
                }
            });
            return () => {
                abort = true;
            };
        }, deps);
        return state;
    }
}
exports.Hooks = Hooks;
//# sourceMappingURL=hooks.js.map